// components/StockVisualizationCharts.js
import React from "react";
import { CandleStick, VWAPLineChart, VolumeBarChart, ChangePercLine } from "./charts";

const StockVisualizationCharts = ({ chartData, selectedPeriod, stockInfo }) => {
  const filterDataByPeriod = (data, period) => {
    if (!data || !data.length ) return data;

    const periodDays = {
      '1W': 7,
      '1M': 30,
      '3M': 90,
      '6M': 180,
      '1Y': 365,
      '3Y': 1095,
      '5Y': 1825
    };

const daysToShow = periodDays[period];
if (!daysToShow) return data;

const sortedData = [...data].sort((a, b) => new Date(b.date) - new Date(a.date));
const sliced = sortedData.slice(0, daysToShow).reverse();

if (['3Y', '5Y', 'MAX'].includes(period)) {
  return sliced.filter((_, i) => i % 30 === 0); // downsample this speeds up rending when selecting 3Y, 5Y, and MAX. Change 10 to 20 for faster rending. e.g. 10 keeps every 10th data point
}

return sliced;


  };

  const filtered = filterDataByPeriod(chartData, selectedPeriod);

  return (
    <>
      <div className="chart-wrapper">
      <CandleStick
          chartData={filtered}
          stockInfo={stockInfo}
          selectedPeriod={selectedPeriod}
        />
      </div>

      
      <div className="chart-wrapper">
        <VWAPLineChart chartData={filtered} 
        stockInfo={stockInfo}
        selectedPeriod={selectedPeriod} />
      </div>
      <div className="chart-wrapper">

      <VolumeBarChart
        chartData={filtered}
        stockInfo={stockInfo}
        selectedPeriod={selectedPeriod}
      />

      </div>
      <div className="chart-wrapper">
        {/* <ChangePercLine chartData={filtered} stockInfo={stockInfo} /> */}

        <ChangePercLine
        chartData={filtered}
        stockInfo={stockInfo}
        selectedPeriod={selectedPeriod}
      />

      </div>
    </>
  );
};

export default StockVisualizationCharts;
